import {useLocation} from 'react-router-dom';

import {Box, useTheme} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import {AppHeaderWrapper} from '../AppHeaderWrapper';
import {SideDrawerWrapper} from '../SideDrawerWrapper';

import {FlagLanguageSwitcher} from '../../../LanguageSwitcher/FlagLanguageSwitcher';

export const PublicAppHeader = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const exceptionRoutes = ['login', 'sign-up', 'b2b'];

  if (isSmallScreen) {
    return <SideDrawerWrapper sideBarSections={[{menuItems: [<FlagLanguageSwitcher key='language-switcher' />]}]} />;
  }

  return (
    <AppHeaderWrapper isTransparent={!exceptionRoutes.some((route) => location.pathname.includes(route))}>
      <Box sx={{display: {xs: 'none', md: 'flex', lg: 'flex', backgroundColor: 'transparent'}}}>
        <FlagLanguageSwitcher />
      </Box>
    </AppHeaderWrapper>
  );
};
